var _toConsumableArray = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _objectSpread = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");

var _classCallCheck = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _require = require('events'),
    EventEmitter = _require.EventEmitter,
    Promise = require('bluebird'),
    _require2 = require('./addresses'),
    isValidPublicFctAddress = _require2.isValidPublicFctAddress,
    _require3 = require('./transaction'),
    Transaction = _require3.Transaction;

var FACTOM_EVENT = {
  newDirectoryBlock: 'newDirectoryBlock',
  newFactoidBlock: 'newFactoidBlock',
  newAdminBlock: 'newAdminBlock',
  newEntryCreditBlock: 'newEntryCreditBlock',
  newChain: 'newChain'
};
Object.freeze(FACTOM_EVENT);
/**
 * Listen for new Factom Events:
 *
 * <ul>
 * <li>newDirectoryBlock - Triggers when blockchain adds a new directory block. Listener receives new directory block.</li>
 * <li>newFactoidBlock - Triggers when blockchain adds a new factoid block. Listener receives new factoid block.</li>
 * <li>newAdminBlock - Triggers when blockchain adds a new admin block. Listener receives new admin block.</li>
 * <li>newEntryCreditBlock - Triggers when blockchain adds a new entry credit block. Listener receives new entry credit block.</li>
 * <li>newChain - Triggers when blockchain adds a new chain. Listener receives first entry block of new chain.</li>
 * <li>FA29eyMVJaZ2tbGqJ3M49gANaXMXCjgfKcJGe5mx8p4iQFCvFDAC - Triggers when factoid address sends or receives a transaction. Listener receives transaction.</li>
 * <li>4060c0192a421ca121ffff935889ef55a64574a6ef0e69b2b4f8a0ab919b2ca4 - Triggers when entry chain adds new entry block. Listener receives entry block.</li>
 * </ul>
 *
 * @class
 * @param {FactomCli} cli - FactomCli instance to be used by the FactomEventEmitter instance to fetch blockchain data.
 * @param {object} [opts] - Options to set on the FactomEventEmitter instance
 * @param {number} [opts.interval=7500] - Interval (ms) at which the FactomEventEmtitter instance should poll the blockchain to check for a new block.
 * @example
 * const { FactomCli, FactomEventEmitter } = require('factom');
 * const cli = new FactomCli();
 * // Poll the blockchain every 10s
 * const emitter = new FactomEventEmitter(cli, { interval: 10000 });
 * emitter.on('newDirectoryBlock', (directoryBlock) => ...);
 * emitter.on('newFactoidBlock', (factoidBlock) => ...);
 * emitter.on('newAdminBlock', (adminBlock) => ...);
 * emitter.on('newEntryCreditBlock', (entryCreditBlock) => ...);
 * emitter.on('newChain', (entryBlock) => ...);
 * // Listen to any transaction involving a given Factoid address
 * emitter.on('FA29eyMVJaZ2tbGqJ3M49gANaXMXCjgfKcJGe5mx8p4iQFCvFDAC', (transaction) => ...);
 * // Listen to any new entries in a given chain
 * emitter.on('4060c0192a421ca121ffff935889ef55a64574a6ef0e69b2b4f8a0ab919b2ca4', (entryBlock) => ...);
 */

var FactomEventEmitter =
/*#__PURE__*/
function (_EventEmitter) {
  "use strict";

  _inherits(FactomEventEmitter, _EventEmitter);

  function FactomEventEmitter(cli, opts) {
    var _this;

    _classCallCheck(this, FactomEventEmitter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FactomEventEmitter).call(this));
    _this._cli = cli;
    _this._lastBlockHeightProcessed = 0;
    _this.opts = _objectSpread({
      interval: 7500
    }, opts); // FCT addresses and chain ids still need to be tracked manually for efficiency

    _this._chainSubscriptions = new Set();
    _this._factoidAddressSubscriptions = new Set();

    _this.on('removeListener', function (event) {
      return _this._removeListener(event);
    });

    _this.on('newListener', function (event) {
      return _this._newListener(event);
    });

    return _this;
  }
  /**
   * Get active chain id subscriptions
   * @returns {Set<string>}
   */


  _createClass(FactomEventEmitter, [{
    key: "_newListener",
    ///////////////////////////////////////////////////////////////
    //                    MANAGE LISTENERS                      //
    /////////////////////////////////////////////////////////////
    // This method only starts polling and keeps track of "custom" events such as FCT addresses and chain ids
    value: function () {
      var _newListener2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(event) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof event !== 'string')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                // Should not start polling when listening to non-blockchain events such as 'error'
                if (this._isBlockchainEvent(event)) {
                  this._startPolling();
                } // Block events are directly handled by the base EventEmitter


                if (!Object.values(FACTOM_EVENT).includes(event)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                if (isValidPublicFctAddress(event)) {
                  this._factoidAddressSubscriptions.add(event);
                } else if (event.match(/\b[A-Fa-f0-9]{64}\b/)) {
                  this._chainSubscriptions.add(event);
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _newListener(_x) {
        return _newListener2.apply(this, arguments);
      }

      return _newListener;
    }() // Counterpart only responsible to stop polling and keep track of custom events

  }, {
    key: "_removeListener",
    value: function () {
      var _removeListener2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(event) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof event !== 'string')) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (this._chainSubscriptions.has(event) && this.listenerCount(event) === 0) {
                  this._chainSubscriptions.delete(event);
                } else if (this._factoidAddressSubscriptions.has(event) && this.listenerCount(event) === 0) {
                  this._factoidAddressSubscriptions.delete(event);
                } // Should only stop polling where there are no blockchain listeners active


                if (!this.eventNames().some(this._isBlockchainEvent)) {
                  this._stopPolling();
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _removeListener(_x2) {
        return _removeListener2.apply(this, arguments);
      }

      return _removeListener;
    }()
  }, {
    key: "_isBlockchainEvent",
    value: function _isBlockchainEvent(event) {
      return Object.values(FACTOM_EVENT).includes(event) || isValidPublicFctAddress(event) || event.match(/\b[A-Fa-f0-9]{64}\b/);
    } ///////////////////////////////////////////////////////////////
    //              POLL DIRECTORY BLOCKS                       //
    /////////////////////////////////////////////////////////////
    // Start polling the blockchain for new directory blocks

  }, {
    key: "_startPolling",
    value: function _startPolling() {
      var _this2 = this;

      // Guard should prevent more than one interval from starting
      if (!this.isPolling) {
        this._poll();

        this._isPolling = setInterval(function () {
          return _this2._poll();
        }, this.opts.interval);
      }
    } // Stop polling for new directory blocks

  }, {
    key: "_stopPolling",
    value: function _stopPolling() {
      if (this.isPolling) {
        clearInterval(this._isPolling);
        this._isPolling = false;
      }
    } // Handle the polling logic

  }, {
    key: "_poll",
    value: function () {
      var _poll2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var block;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this._cli.getDirectoryBlockHead();

              case 3:
                block = _context3.sent;

                if (block.height > this._lastBlockHeightProcessed) {
                  this._lastBlockHeightProcessed = block.height;

                  this._handleDirectoryBlock(block);
                }

                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                this.emit('error', _context3.t0);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function _poll() {
        return _poll2.apply(this, arguments);
      }

      return _poll;
    }() // Emit new directory blocks then trigger other emitter functions as appropriate

  }, {
    key: "_handleDirectoryBlock",
    value: function _handleDirectoryBlock(block) {
      var _this3 = this;

      this.emit(FACTOM_EVENT.newDirectoryBlock, block);

      if (this.listenerCount(FACTOM_EVENT.newAdminBlock) > 0) {
        this._emitAdminBlock(block);
      }

      if (this.listenerCount(FACTOM_EVENT.newEntryCreditBlock) > 0) {
        this._emitEntryCreditBlock(block);
      }

      if (this.listenerCount(FACTOM_EVENT.newFactoidBlock) > 0 || this._factoidAddressSubscriptions.size > 0) {
        this._emitFactoidBlock(block);
      }

      if (this.listenerCount(FACTOM_EVENT.newChain) > 0) {
        this._emitNewChains(block);
      }

      var entryBlockRefs = block.entryBlockRefs.filter(function (ref) {
        return _this3._chainSubscriptions.has(ref.chainId);
      });

      if (entryBlockRefs.length > 0) {
        this._emitEntryBlock(entryBlockRefs);
      }
    } ///////////////////////////////////////////////////////////////
    //                      EVENT EMITTERS                      //
    /////////////////////////////////////////////////////////////
    // Emit factoid block and/or trigger factoid transaction emitter function

  }, {
    key: "_emitFactoidBlock",
    value: function () {
      var _emitFactoidBlock2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(directoryBlock) {
        var factoidBlock;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this._cli.getFactoidBlock(directoryBlock.factoidBlockRef);

              case 3:
                factoidBlock = _context4.sent;

                if (this.listenerCount(FACTOM_EVENT.newFactoidBlock) > 0) {
                  this.emit(FACTOM_EVENT.newFactoidBlock, factoidBlock);
                }

                if (this._factoidAddressSubscriptions.size > 0) {
                  // Must pass directoryBlock through to access block context
                  this._emitFactoidTransaction(factoidBlock, directoryBlock);
                }

                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);
                this.emit('error', _context4.t0);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));

      function _emitFactoidBlock(_x3) {
        return _emitFactoidBlock2.apply(this, arguments);
      }

      return _emitFactoidBlock;
    }()
  }, {
    key: "_emitAdminBlock",
    value: function () {
      var _emitAdminBlock2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(directoryBlock) {
        var adminBlock;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this._cli.getAdminBlock(directoryBlock.adminBlockRef);

              case 3:
                adminBlock = _context5.sent;
                this.emit(FACTOM_EVENT.newAdminBlock, adminBlock);
                _context5.next = 10;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                this.emit('error', _context5.t0);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function _emitAdminBlock(_x4) {
        return _emitAdminBlock2.apply(this, arguments);
      }

      return _emitAdminBlock;
    }()
  }, {
    key: "_emitEntryCreditBlock",
    value: function () {
      var _emitEntryCreditBlock2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(directoryBlock) {
        var entryCreditBlock;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this._cli.getEntryCreditBlock(directoryBlock.entryCreditBlockRef);

              case 3:
                entryCreditBlock = _context6.sent;
                this.emit(FACTOM_EVENT.newEntryCreditBlock, entryCreditBlock);
                _context6.next = 10;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                this.emit('error', _context6.t0);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function _emitEntryCreditBlock(_x5) {
        return _emitEntryCreditBlock2.apply(this, arguments);
      }

      return _emitEntryCreditBlock;
    }() // Emit the first entry block of any newly created entry chain.

  }, {
    key: "_emitNewChains",
    value: function () {
      var _emitNewChains2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(directoryBlock) {
        var _this4 = this;

        var checkIfNewChainAndEmit;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                checkIfNewChainAndEmit =
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee7(ref) {
                    var entryBlock;
                    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            _context7.next = 2;
                            return _this4._cli.getEntryBlock(ref.keyMR);

                          case 2:
                            entryBlock = _context7.sent;

                            if (entryBlock.sequenceNumber === 0) {
                              _this4.emit(FACTOM_EVENT.newChain, entryBlock);
                            }

                          case 4:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function checkIfNewChainAndEmit(_x7) {
                    return _ref.apply(this, arguments);
                  };
                }(); // Fetch entry chains contained in directory block concurrently


                _context8.next = 4;
                return Promise.map(directoryBlock.entryBlockRefs, checkIfNewChainAndEmit, {
                  concurrency: 10
                });

              case 4:
                _context8.next = 9;
                break;

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8["catch"](0);
                this.emit('error', _context8.t0);

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 6]]);
      }));

      function _emitNewChains(_x6) {
        return _emitNewChains2.apply(this, arguments);
      }

      return _emitNewChains;
    }() // Emit the latest entry block of any entry chain the user is listening to.

  }, {
    key: "_emitEntryBlock",
    value: function () {
      var _emitEntryBlock2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(entryBlockRefs) {
        var _this5 = this;

        var fetchAndEmitNewBlock;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                fetchAndEmitNewBlock =
                /*#__PURE__*/
                function () {
                  var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee9(ref) {
                    var entryBlock;
                    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.prev = 0;
                            _context9.next = 3;
                            return _this5._cli.getEntryBlock(ref.keyMR);

                          case 3:
                            entryBlock = _context9.sent;

                            _this5.emit(ref.chainId, entryBlock);

                            _context9.next = 10;
                            break;

                          case 7:
                            _context9.prev = 7;
                            _context9.t0 = _context9["catch"](0);

                            _this5.emit('error', _context9.t0);

                          case 10:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9, null, [[0, 7]]);
                  }));

                  return function fetchAndEmitNewBlock(_x9) {
                    return _ref2.apply(this, arguments);
                  };
                }(); // Fetch new entry blocks concurrently


                _context10.next = 3;
                return Promise.map(entryBlockRefs, fetchAndEmitNewBlock, {
                  concurrency: 10
                });

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function _emitEntryBlock(_x8) {
        return _emitEntryBlock2.apply(this, arguments);
      }

      return _emitEntryBlock;
    }() // Emit new factoid transactions for user-defined addresses

  }, {
    key: "_emitFactoidTransaction",
    value: function _emitFactoidTransaction(factoidBlock, directoryBlock) {
      var _this6 = this;

      var addrs = this._factoidAddressSubscriptions;
      factoidBlock.transactions.forEach(function (tx) {
        // Search transaction inputs and outputs for user-defined addresses
        var activeAddresses = new Set([].concat(_toConsumableArray(tx.inputs), _toConsumableArray(tx.factoidOutputs)).filter(function (io) {
          return addrs.has(io.address);
        }).map(function (io) {
          return io.address;
        }));

        if (activeAddresses.size > 0) {
          // Add the block context to the transaction prior to emitting
          var transaction = new Transaction(Transaction.builder(tx), {
            factoidBlockKeyMR: directoryBlock.factoidBlockRef,
            directoryBlockHeight: directoryBlock.height,
            directoryBlockKeyMR: directoryBlock.keyMR
          });
          activeAddresses.forEach(function (address) {
            return _this6.emit(address, transaction);
          });
        }
      });
    }
  }, {
    key: "chainSubscriptions",
    get: function get() {
      return this._chainSubscriptions;
    }
    /**
     * Get active factoid address subscriptions
     * @returns {Set<string>}
     */

  }, {
    key: "factoidAddressSubscriptions",
    get: function get() {
      return this._factoidAddressSubscriptions;
    }
    /**
     * Determine whether or not polling is currently active.
     * @returns {boolean}
     */

  }, {
    key: "isPolling",
    get: function get() {
      return !!this._isPolling;
    }
  }]);

  return FactomEventEmitter;
}(EventEmitter);

module.exports = {
  FactomEventEmitter: FactomEventEmitter,
  FACTOM_EVENT: FACTOM_EVENT
};